import React, { useState } from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { useIntl, FormattedMessage } from 'react-intl'
import { Button, Typography } from '@material-ui/core'

import { SUBMIT } from 'app/constants/button'
import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'

const ScheduledDate = (props) => {
  const {
    id,
    scheduledDate,
    scheduleCanceledDate,
    scheduleCancelBy = {
      firstName: '',
      lastName: '',
    },
    isAction = false,
    onCancelSchedule = () => {},
  } = props
  const { formatMessage } = useIntl()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      {scheduledDate && scheduleCanceledDate ? (
        <Typography className="text-14 text-red-500">
          <FormattedMessage
            id="timeline.detail.message.cancel.scheduled"
            values={{
              scheduledTime: moment(scheduledDate).format('LT'),
              scheduledDate: moment(scheduledDate).format('MMM DD, YYYY'),
              cancelBy: `${scheduleCancelBy.firstName} ${scheduleCancelBy.lastName}`,
              cancelDate: moment(scheduleCanceledDate).format('MMM DD, YYYY'),
              cancelTime: moment(scheduleCanceledDate).format('LT'),
              b: (text) => <b>{text}</b>,
            }}
          />
        </Typography>
      ) : (
        <div className="flex justify-between items-center">
          <Typography className="text-14 text-primary">
            <FormattedMessage
              id="timeline.detail.message.scheduled"
              values={{
                time: moment(scheduledDate).format('LT'),
                date: moment(scheduledDate).format('MMM DD, YYYY'),
                b: (text) => <b>{text}</b>,
              }}
            />
          </Typography>
          {isAction ? (
            <Button
              className="text-14 normal-case text-orange-500 py-0 h-0 hover:bg-transparent"
              disableRipple
              onClick={() => {
                setIsOpen(true)
              }}
            >
              {formatMessage({
                id: 'timeline.detail.message.dialog.title.scheduled',
              })}
            </Button>
          ) : null}
        </div>
      )}
      <SubmitDialog
        id={`dialog-cancel-schedule-timeline`}
        open={isOpen}
        type={SUBMIT}
        title={formatMessage({
          id: 'timeline.detail.message.dialog.title.scheduled',
        })}
        description={formatMessage({
          id: 'timeline.detail.message.dialog.description.scheduled',
        })}
        submitText={formatMessage({
          id: 'text.yse.cancel',
        })}
        onSubmit={async () => {
          await onCancelSchedule(id)
          setIsOpen(false)
        }}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => setIsOpen(false)}
      />
    </>
  )
}

ScheduledDate.propTypes = {
  id: PropTypes.number,
  scheduledDate: PropTypes.string,
  scheduleCanceledDate: PropTypes.string,
  scheduleCancelBy: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
  isAction: PropTypes.bool,
  onCancelSchedule: PropTypes.func,
}

export default ScheduledDate
